/* @flow */

import { assertObject } from '@braindate/util/lib/assert';

import type { State } from 'src/shared/core/type/reduxTypes';

export function getEntities(state: State): Object {
  assertObject(state, 'state');

  const { domain } = state;

  assertObject(domain, 'domain');

  const { entities } = domain;

  assertObject(entities, 'entities');

  return entities;
}

export function parseIdFromProps(state: State, props: Object): number | string {
  assertObject(state, 'state');
  assertObject(props, 'props');

  return props.id;
}
